"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default_sankey_plus_style_link = void 0;
const SankeyUtils_1 = require("open-sankey/dist/SankeyUtils");
const default_sankey_plus_style_link = () => {
    const style = SankeyUtils_1.default_link_style();
    style.gradient = false;
    return style;
};
exports.default_sankey_plus_style_link = default_sankey_plus_style_link;
